/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import React from 'react';

import LogsService from 'src/services/LogsService';
import FallbackUI from '../FalbackUI';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  id: string;
  error?: any;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, id: '' };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI

    return { hasError: true, id: '' };
  }

  componentDidCatch(error: any) {
    (async () => {
      try {
        const response = await LogsService
          .createLog(error.name, error.message, error);

        this.setState((state) => ({
          ...state,
          id: response.cdId,
          error,
        }));
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    })();
  }

  render() {
    const { hasError, id, error } = this.state;
    const { children } = this.props;

    // Check if the error is thrown
    if (hasError) {
      // You can render any custom fallback UI
      return (

        <FallbackUI id={id} error={error} />
      );
    }

    // Return children components in case of no error

    return children;
  }
}

export default ErrorBoundary;
